import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import MessageBox from "./MessageBox";
import api from "../services/api.service";
import * as Styles from "../styles/Confirmation.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";

const ConfirmationModal: React.FC<{
  isOpen: boolean;
  title: string;
  description: string;
  confirmationAction: () => void;
  cancelationAction: () => void;
  onRequestClose: () => void;
}> = ({ isOpen, title, description, confirmationAction, cancelationAction, onRequestClose }) => {
  const {
    subsidiaryDataZustand,
    setOrderDataZustand,
    orderDataZustand,
    authUserZustand,
    setMessageZustand,
  } = useCombinedStore((state) => {
    return {
      setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
      subsidiaryDataZustand: state.subsidiaryDataZustand,
      setOrderDataZustand: state.setOrderDataZustand,
      orderDataZustand: state.orderDataZustand,
      setMessageZustand: state.setMessageZustand,
      authUserZustand: state.authUserZustand,
    };
  });
  const modalWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => { }, [setOrderDataZustand, orderDataZustand]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      confirmationAction();
    }
  };

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        modalWrapperRef.current?.focus();
      }, 50);
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onRequestClose()}
      style={Styles.customStyles}
      contentLabel="Main Modal"
      ariaHideApp={false}
    >
      <MessageBox />
      <Styles.ModalWrapper
        tabIndex={-1}
        ref={modalWrapperRef}
        onKeyDown={handleKeyDown}
      >
        <Styles.ModalContent>
          <Styles.ModalHeader
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
            <Styles.ModalTitle>{title}</Styles.ModalTitle>
            <Styles.ModalDescription>{description}</Styles.ModalDescription>
          </Styles.ModalHeader>
          <Styles.ModalFooter
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Button onClick={() => {
              cancelationAction();
              onRequestClose();
            }}>
              Cancelar
            </Styles.Button>
            <div style={{ display: "flex" }}>
              <Styles.Button onClick={confirmationAction}>Confirmar</Styles.Button>
            </div>
          </Styles.ModalFooter>
        </Styles.ModalContent>
      </Styles.ModalWrapper>
    </Modal>
  );
};

export default ConfirmationModal;
